import styled from 'styled-components';

export const Preview = styled.img`
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
  transition: transform 0.2s;
  position: relative;
  user-select: none;
`;

export const PreviewWrapper = styled.div`
  height: 100%;
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;

export const PanOverlay = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  top: 0;
  left: 0;
  position: absolute;
`;

export const ZoomWrapper = styled.div`
  width: 90px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 2;
`;
